import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    placing_ads_kol_owner_query,
    placing_ads_kol_query,
    placing_ads_kol_save,
    placing_ads_kol_decrypt_auth_code_apply,
    placing_ads_kol_decrypt_auth_code_check_and_decrypt,
    placing_ads_kol_export,
    placing_ads_kol_delete,
    placing_ads_kol_add_enjoy_customer,
    placing_ads_kol_delete_enjoy_customer,
    placing_ads_kol_detail
 } = util.api || {}

 export function getplacingAdsKolQueryListApi(params) {
    return http.get(placing_ads_kol_query, params)
}

export function postPlacingAdsKolSaveApi(params) {
    return http.post(placing_ads_kol_save, params)
}

export function getPlacingAdsKolOwnerQueryApi(params) {
    return http.get(placing_ads_kol_owner_query, params)
}

export function postPlacingAdsKolDecryptAuthCodeApplyApi(params) {
    return http.post(placing_ads_kol_decrypt_auth_code_apply, params)
}

export function postPlacingAdsKolDecryptAuthCodeCheckAndDecryptApi(params) {
    return http.post(placing_ads_kol_decrypt_auth_code_check_and_decrypt, params)
}

export function postPlacingAdsKolDeleteApi(params) {
    return http.post(placing_ads_kol_delete, params)
}

export function postPlacingAdsKolAddEnjoyCustomerApi(params) {
    return http.post(placing_ads_kol_add_enjoy_customer, params)
}

export function postPlacingAdsKolDeleteEnjoyCustomerApi(params) {
    return http.post(placing_ads_kol_delete_enjoy_customer, params)
}

// placing_ads_kol_detail
export function getPlacingAdsKolDetailApi(params) {
    return http.get(placing_ads_kol_detail, params)
}